module.exports = __webpack_public_path__ + "static/media/service7.f4f9434c.svg";